<template>
<div> 
  <template v-if="finishAmendMode && done">
    <CustomerCacheNew v-if="isAmendV && editOrderMode == 1" @updateRouterStatus="updateRouterStatus"></CustomerCacheNew>
    <customer-cache v-else @updateRouterStatus="updateRouterStatus"></customer-cache>
  </template>
</div>
</template>

<script>
  import customerCache, {CustomerCacheNew} from '@/pagesCache/customer/index'
  import {getUrlParameter} from '@/utils/assist'
  import {mapState} from 'vuex';
  export default {
    layout: 'sidebar',
    name: 'customer',
    computed: {
      ...mapState({
        finishAmendMode: state => state.booking.user.finishAmendMode, // 用户地址
        isAmend: state => state.booking.user.orderAmend.isAmend, // 修改订单状态 这里一开始是初始值，所以使用该值会先显示旧customCache.vue,然后进入customCache.vue后把isAmend修改回true后，再显示了CustomerCacheNew.vue。
      }),
    },
    data(){
      return {
        leave: true,
        editOrderMode:0,
        isAmendV: false,
        done: false,
      }
    },
    created () {
      this.init();
    },
    activated() {
      console.log('pages custom.vue activated...');
      this.done = false;
      if(this.$route.params.local) {
        this.isAmendV = true;
      }
      this.init();
      setTimeout(() => {
        this.done = true;
      }, 1000);
    },
    deactivated() {
      this.done = false;
    },
    mounted() {
      console.log('pages custom.vue mounted...');
    },
    methods:{
      init() {
        // if(!this.finishAmendMode) {
          let urlObj = getUrlParameter();
          if (typeof urlObj === 'object' && urlObj.hasOwnProperty('platformKey') && urlObj.hasOwnProperty('orderId')) { // OCRM链接跳转入口 修改订单初始化
            this.isAmendV = true;
            this.server.setPublicData({platformKey: urlObj.platformKey});
          }else {
          }
        // }

        this.getPlatformByKey()

        
        console.log()
  

      },
      updateFinish() {
        this.$store.commit('booking/user/update', {
              finishAmendMode: true
            });
      },
      updateRouterStatus (isLeave) {
        this.leave = !!isLeave
      },
      getPlatformByKey(){
        this.server.get({name: 'getPlatformByKey', data: {}}).then((res) => {
          if (res.status === 1) {
            this.editOrderMode = res.data.editOrderMode;
            this.$store.dispatch('booking/user/update', {newAmend: this.editOrderMode})
            this.updateFinish();
          }
        }).catch(() => {
          this.updateFinish();
        })
      },
    },
    watch: {
      finishAmendMode (n) {
      },
      isAmend (n) {
        if(n) this.isAmendV = true;
      },
    },
    beforeRouteLeave (to, from , next) {
      if (this.leave) next();
      else {
        this.$Modal.error({
          title: '提示',
          content: '数据加载中'
        });
        next(false);
      }
    },
    components: {
      customerCache,
      CustomerCacheNew
    }
  }
</script>




// WEBPACK FOOTER //
// pages/customer.vue